import { Box, Grid, Table, Typography } from "@mui/material";
import React from "react";
import { estraiDatiIndirizzo } from "../../../../lib/datautils";
import TabelleEntries from "../../../TabelleEntries";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
const {logger} = useBSSLogger();

//tab con località e pacchi
const TabStep1 = ({ ordine, tabObj }) => {

    const { indirizzomittente = {}, indirizzodestinatario = {}, righe = [] } = ordine;

    const datiMitt = estraiDatiIndirizzo(indirizzomittente);
    const datiDest = estraiDatiIndirizzo(indirizzodestinatario);
    const datiPacchi = {
        [__t("staispedendo")]: `${ordine.righe.length} ${ordine.tipospedizione.descrizione}`,
        [__t("valoredichiarato")]: `€ ${ordine.valmerce.toFixed(2)}`,
        [__t("pesotot")]: `kg ${ordine.totkg}`,
        [__t("volumetot")]: `mc ${ordine.totmtcubi}`
    };

    const tabelleDettaglioPacchi = ordine.righe.reduce((obj, pacco, indicePacco) => {
        logger.debug("righe ordine", pacco);
        const contenuto = pacco?.naturamerce?.multiDescr?.testo ?? pacco?.naturamerce?.codice ?? null;

        if (contenuto !== null) {
            obj = {
                ...obj,
                [`${__t("dettagliopacchi", [ordine.tipospedizione.descrizione])}: #${indicePacco + 1}`]: {
                    [__t("natmerce")]: contenuto,
                    [__t("largh")]: pacco.basemassima.toFixed(2),
                    [__t("lungh")]: pacco.baseminima.toFixed(2),
                    [__t("alt")]: pacco.altezza.toFixed(2),
                    [__t("peso")]: pacco.pesokg.toFixed(2),
                    [__t("qta")]: pacco.quantita,
                }
            };
        }
        return {
            ...obj
        };
    }, {});

    const tabellaMittente = {
        [__t("mittente")]: datiMitt,
    };

    const tabellaDestinatario = {
        [__t("destinatario")]: datiDest,
    };

    const tabellaPacchi = {
        [`${__t("riepilogo")} ${ordine.tipospedizione.descrizione}`]: datiPacchi,
    };

    const tabellaMittenteDestinatario = {
        [__t("mittente")]: datiMitt,
        [__t("destinatario")]: datiDest,
        [`${ordine.tipospedizione.descrizione}`]: datiPacchi,
        ...tabelleDettaglioPacchi
    };

    return (
        <Typography variant={"body1"}>
            <Box sx={{ display: ["none", "none", "none", "block"] }}>
                <Grid container columns={12} spacing={2}>

                    <Grid item xs={6}>                        
                        <TabelleEntries wrapped  tabelle={tabellaMittente} />                        
                    </Grid>
                    <Grid item xs={6}>                        
                        <TabelleEntries wrapped  tabelle={tabellaDestinatario} />                        
                    </Grid>

                    <Grid item xs={12}>                        
                        <TabelleEntries wrapped tabelle={tabellaPacchi} />                        
                    </Grid>

                    <Grid item xs={12}>                        
                        <TabelleEntries wrapped tabelle={tabelleDettaglioPacchi} />                        
                    </Grid>

                </Grid>
            </Box>
            <Box sx={{ display: ["block", "block", "block", "none"] }}>
                <Grid container columns={12} spacing={2}>
                    <Grid item xs={12}>                        
                        <TabelleEntries wrapped tabelle={tabellaMittenteDestinatario} />                        
                    </Grid>
                </Grid>
            </Box>

        </Typography>
    );
};

export default TabStep1;